export const mutations = {
    setPortadorFinanceiro(state, data) {
        state.portadorFinanceiro = data
    },
    setPortadoresFinanceiro(state, data) {
        state.portadoresFinanceiro = data
    },
    addPortadorFinanceiro(state, data){
        state.portadoresFinanceiro.push(data)
    },
    removePortadorFinanceiro(state, data){
        let index = state.portadoresFinanceiro.map(x => x.id).indexOf(data.id);
        state.portadoresFinanceiro.splice(index, 1)
    },
    setModalCadastroPortadorFinanceiro(state, status) {
        state.modalCadastroPortadorFinanceiro = status
    },
    setModalExcluirPortadorFinanceiro(state, status) {
        state.modalExcluirPortadorFinanceiro = status
    },
    setModalListarPortadorFinanceiro(state, status) {
        state.modalListarPortadorFinanceiro = status
    },
    
}

export default {}